import { useEffect, useMemo, useState } from "react";
import myImage from "../../SVG/LoginAdm.svg";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import autService from "../../services/authService";
import WebApi from "../../Api/WebApi";
import OperationStatus from "../../config/OperationStatus";
import { GoogleLogin } from "@react-oauth/google";
import { getLoginPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { StrapiError } from '../../Inicio/Pages/StrapiError';

export default function Login() {
  const { handleSubmit } = useForm();

  const { locale } = useLocale();
  const [loginPage, setloginPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [hasError, setHasError] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();


  const onSubmit = async (data) => {
    let res = await autService.loginAdm(data, dispatch);
    if (res.operationStatus === OperationStatus.SUCCESS) {
      localStorage.setItem("token", res.result.token);
      localStorage.setItem(
        "refreshToken",
        JSON.stringify(res.result.refreshToken)
      );

      WebApi.setAuthToken(res.result.token);
      navigate("/Admin");
    } else {
      toast.error(res.message);
    }
  };
  const handleCallbackResponse = async (response) => {
    let res = await autService.loginGoogleAdm(response.credential, dispatch);
    if (res.operationStatus === OperationStatus.SUCCESS) {
      localStorage.setItem("token", res.result.token);
      localStorage.setItem(
        "refreshToken",
        JSON.stringify(res.result.refreshToken)
      );

      WebApi.setAuthToken(res.result.token);
      navigate("/Admin");
    } else {
      toast.error(res.message);
    }
  };

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    // Timeout para evitar carga eterna
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setloginPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 5000);

    getLoginPage(locale)
      .then((res) => {
        clearTimeout(timeoutId);
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setloginPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch((error) => { 
        clearTimeout(timeoutId);
        if (!cancel) {
          setloginPage(null);
          setIsLoadingContent(false);
          // Solo mostrar error si el idioma es inglés
          const shouldShowError = locale === 'en';
          setHasError(shouldShowError);
        }
      });
    return () => { 
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale])

  if (isLoadingContent) {
    return (
      <div className="rootLogin">
        <div className="loginContainer">
          <div className="grid-container col-2 col-md col-sm-12">
            <div className="grid-item justify-self-center reverse login-item">
              <Skeleton.Image style={{ width: 400, height: 400 }} active />
            </div>
            <div className="grid-item justify-self-center login-item">
              <Skeleton.Input style={{ width: 400, height: 40 }} active />
              <br />
              <Skeleton.Input style={{ width: 200, height: 30 }} active />
              <br />
              <div className="loginFlex">
                <Skeleton.Button style={{ width: 200, height: 50 }} active />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }else if (hasError && locale === 'en') {
    return <StrapiError 
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setloginPage(null);
      }}
    />
  }

  return (
    <div className="rootLogin">
      <div className="loginContainer">
        <div className="grid-container col-2 col-md col-sm-12 ">
          <div className="grid-item justify-self-center reverse login-item">
            <img
              className="img-login"
              src={myImage}
              alt="Imagen de inicio de sesión"
            />
          </div>
          <div className="grid-item justify-self-center login-item">
            <h1>{loginPage?.title || "ADMINISTRACIÓN DE ADMISIONES CENFOTEC"}</h1>
            <br></br>
            <h2>{loginPage?.subtitle || "Inicio de sesión"}</h2>
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="loginFlex">
                <GoogleLogin
                  onSuccess={(credentialResponse) => {
                    handleCallbackResponse(credentialResponse);
                  }}
                  onError={() => {
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
